import { render, staticRenderFns } from "./ChatRail.vue?vue&type=template&id=03e4ddf3&scoped=true"
import script from "./ChatRail.vue?vue&type=script&lang=js"
export * from "./ChatRail.vue?vue&type=script&lang=js"
import style0 from "./ChatRail.vue?vue&type=style&index=0&id=03e4ddf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e4ddf3",
  null
  
)

export default component.exports